import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/api/downloadPersons', request, cancelToken, {responseType: 'arraybuffer'})
}
export {get}
